import { create } from 'zustand';

const useVibeStore = create((set) => ({
    // null, 'waiting_for_proceed', 'waiting_for_run_terminal', 'waiting_for_accept_terminal', 'waiting_for_accept_changes'
    pendingAction: null,

    // The session this action is tied to
    chatId: null,

    // The visual context captured by the agent
    screenshotUrl: null,

    // Methods
    setPendingAction: (action, chatId, screenshotUrl) =>
        set({ pendingAction: action, chatId, screenshotUrl }),

    clearPendingAction: () =>
        set({ pendingAction: null, chatId: null, screenshotUrl: null }),
}));

export default useVibeStore;
